import { Typography, RadioGroup, Container, Toolbar, Divider, Button, AppBar, Drawer, alpha, Menu, Grid, Box, Card, keyframes } from "@mui/material";
import { styled } from "@mui/styles";
import { fastpasinfoUrlbg } from "../data";

const fadeInDown = keyframes`
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;
const pulsate = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0.6;
  }
`;

///// Home Outer Components
export const HomeWrapper = styled("div")(({ theme }) => ({
  // backgroundColor: theme.palette.primary.main,
  // fontFamily: theme.typography.fontFamily,
  // marginTop: theme.spacing(-10),
  // backgroundColor: "#f6f6f6",
  // overflow: "hidden",
}));

///// Header
export const HeaderWrapper = styled(Box)(({ theme }) => ({
  // backgroundColor: theme.palette.awasbandhu.primary.main,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  // padding: "0 2%",
  height: "30px",
  paddingLeft: '13px',
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
}));
//LeftContent
export const LeftContent = styled(Box)(({ theme }) => ({
  marginLeft: "0%",
  fontSize: theme.typography.fontSize,
  color: "#fff",
}));

export const DepartmentButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  backgroundColor: "rgb(61 157 149)",
  fontSize: theme.typography.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "rgb(50 109 104)",
    color: "#fff",
  },
}));

export const RightButtonContent = styled(Box)(({ theme }) => ({
  marginRight: "5%",
  display: "flex",
  alignItems: "center",
  color: "#fff",
  height: "2.5rem",
}));
export const RightContent = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  alignItems: "center",
}));
export const HeaderGovtWrapper = styled(Box)(({ theme }) => ({
  position: "sticky",
  animation: "fill 11s linear",
  animationFillMode: "forwards",
  top: "0",
  left: "0",
  right: "0",
  zIndex: "1000",
  // position: "sticky",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  // padding: "10px 0px 10px 0px ",
  minHeight: "1rem",
  background: `url("https://dot.gov.in/sites/all/themes/cmf/images/top-bg.png")`,
  borderWidth: "2px 2px 0 2px", // top, right, bottom (none), left
  borderColor: "rgb(17, 27, 40)",
  borderStyle: "solid",
  [`@media (max-width: 1024px)`]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
  backgroundColor: "rgb(237, 240, 244)",
}));
export const LeftGovtContent = styled(Box)(({ theme }) => ({
  backgroundImage: "	https://dot.gov.in/sites/all/themes/cmf/images/top-bg.png",
  backgroundColor: "rgb(237, 240, 244)",
  marginLeft: "1%",
  marginRight: "1%",
  minHeight: "60px",
  [`@media (max-width: 500px)`]: {
    marginLeft: "0.5%",
    marginBottom: "0.1rem",
  },
}));
export const RightGovtContent = styled("div")(({ theme }) => ({
  display: "flex",
  marginRight: "0%",
  alignItems: "right ",
  backgroundColor: "rgb(237, 240, 244)",
  // width: "350px",
  [`@media (max-width: 400px)`]: {
    marginLeft: "20%",
  },
}));

export const TopBarWrapper = styled("div")(({ theme }) => ({
  position: "sticky",
  zIndex: 1000,
  top: 0,
}));

export const SlideWrapper = styled("div")(({ bgimg, isLoaded }) => ({
  width: "70%",
  height: "400px",
  float: "left",
  background: `
          linear-gradient(rgba(0, 30, 139, 0.2), rgba(0, 30, 139, 0.3)),
          url('${bgimg}') center center / cover no-repeat
        `,
  filter: isLoaded ? "none" : "blur(10px)",
  transition: "background 1.5s ease-in-out, filter 0.5s ease",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    zIndex: 1,
  },
}));

export const LoginCardWrapper = styled("div")(({ theme, bgimg }) => ({
  width: "30%",
  height: "400px",
  float: "right",
  background: `linear-gradient(#00000070,#0000007d), url('https://i.ibb.co/QvT4DmKv/sidebar.jpg') center center / cover no-repeat`, // Apply dimming effect
  transition: `background 1.5s ease-in-out`,
  // minHeight: `calc(80dvh - 50px)`,
  position: "relative",
  // [theme.breakpoints.up("lg")]: {
  //   minHeight: `calc(80dvh - 50px)`,
  // },
  "::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)", // Add a semi-transparent overlay
    zIndex: 1, // Ensure the overlay is on top of the background
  },
}));

export const SlideLoginCardWrapper = styled("div")(({ theme, bgimg }) => ({
  width: "100%",
  height: "378px",
  background: `linear-gradient(rgba(0, 30, 139, 0.3), rgba(0, 30, 139, 0.3)), url('${bgimg}') center center / cover no-repeat`, // Apply dimming effect
  transition: `background 1.5s ease-in-out`,
  // minHeight: `calc(80dvh - 50px)`,
  position: "relative",
  // [theme.breakpoints.up("lg")]: {
  //   minHeight: `calc(80dvh - 50px)`,
  // },
  "::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)", // Add a semi-transparent overlay
    zIndex: 1, // Ensure the overlay is on top of the background
  },
}));

export const SlideText = styled(Box)(({ theme }) => ({
  position: "absolute",
  width: "80%",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 2, // Place the text above the overlay
  color: "white", // Adjust text color
  textAlign: "center",
  padding: "0 2rem",
  [theme.breakpoints.up("lg")]: {
    //fontSize: '1.5rem',
  },
}));
export const WelcomeSlideText = styled(Box)(({ theme, isVisible }) => ({
  fontSize: "1.5rem",
  fontWeight: "800",
  transform: isVisible ? "translateY(0)" : "translateY(-100%)", // Start off-screen (upwards)
  opacity: isVisible ? 1 : 0, // Fade-in effect
  transition: "transform 1s ease-in-out, opacity 1s ease-in-out",
  fontFamily: '"Raleway", sans-serif',
}));
export const EDCRSlideText = styled(Box)(({ theme }) => ({
  fontSize: "1.50rem",
  fontFamily: '"Raleway", sans-serif',
  fontWeight: "500",
  lineHeight: "1.2",
  marginTop: "1rem",
}));
export const ParaSlideText = styled(Box)(({ theme, isVisible }) => ({
  fontFamily: '"Raleway", sans-serif',
  marginTop: "1rem",
  fontWeight: "600",
  fontSize: "1rem",
  transform: isVisible ? "translateY(0)" : "translateY(-100%)", // Start off-screen (upwards)
  opacity: isVisible ? 1 : 0, // Fade-in effect
  transition: "transform 2s ease-in-out, opacity 2s ease-in-out",
}));
export const FASTPasHeader = styled(Box)(({ theme }) => ({
  textAlign: "center",
  position: "relative",
  marginTop: "1.5rem",
}));

export const TopButton = styled("div")(({ theme }) => ({
  position: "relative",
  float: "right",
  width: "100%",
  right: "10px",
  bottom: "80px",
  height: "10px",
  fontSize: "3rem",
  zIndex: "1",
  cursor: "pointer",
  color: "#CFE8DF",
}));

export const StreamText = styled("div")(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: "600",
  paddingBottom: "1.25rem",
  lineHeight: "1.2",
  color: theme.palette.awasbandhu.primary.main,
  position: "relative", // Ensure that the pseudo-element will be positioned relative to this container
  "&::after": {
    content: '""',
    position: "absolute",
    display: "block",
    width: "4rem", // Adjust width as needed
    height: "3px", // Thickness of the underline
    backgroundColor: "#5cb874", // Green color for the underline
    left: "50%", // Start the underline in the middle
    transform: "translateX(-50%)", // Move the underline back to be centered
    bottom: 0, // Aligns at the bottom of the text
  },
}));
export const FastPasPanelWrapper = styled("div")({
  display: "flex",
  justifyContent: "space-around",
  // alignItems: "center",
  padding: "1rem",
  gap: "0.5rem",
});

export const VideoBox = styled("div")({
  width: "100%",
  height: "100%",
  backgroundImage: `url(${fastpasinfoUrlbg})`, // Updated background image
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  position: "relative",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center", // Aligns the play button in the center of the box
  "&::before": {
    content: '""',
    position: "absolute",
    width: "6rem",
    height: "6rem",
    borderRadius: "50%",
    background: "#5cb874", // Red semi-transparent background
    border: "5px solid #ffffff", // Accent-color border
    zIndex: 1, // Ensure it's above the background image
    animation: `${pulsate} 2s infinite`, // Pulsating effect
  },
  "&::after": {
    content: '""',
    position: "absolute",
    width: "0",
    height: "0",
    borderLeft: "30px solid white", // Bigger triangle (play icon) in white
    borderTop: "20px solid transparent",
    borderBottom: "20px solid transparent",
    borderRight: "-5px solid transparent",
    left: "calc(50% + 5px)", // Shift the triangle slightly to the right
    top: "50%",
    transform: "translate(-50%, -50%)", // Center vertically and horizontally
    zIndex: 2, // Ensure it's above the pulsating circle
  },
});

export const ContentBox = styled("div")(({ theme }) => ({
  width: "100%",
  // display: "flex",
  transform: "translateY(-7.5rem)",
  flexDirection: "column",
  justifyContent: "flex-start", // Aligns content at the top
  alignItems: "flex-start", // Aligns content to the left
  textAlign: "justify",
  "& h1": {
    fontSize: "3rem",
    fontWeight: "bold",
    color: theme.palette.awasbandhu.primary.main,
    marginBottom: "0.5rem",
    textDecoration: "none",
  },
  "& p": {
    fontSize: "1rem",
    marginBottom: "0.5rem",
    lineHeight: "1.5",
    textAlign: "justify",
  },
}));
export const CardsWrappers = styled("div")({
  display: "flex",
  justifyContent: "space-between", // Even spacing between cards
  padding: "2rem", // Padding to create left and right space
  gap: "1.5rem", // Space between cards
  height: "fit-content",
  flexWrap: "wrap",
  marginBottom: "2rem",
});

// Individual card styling
export const InfoCard = styled(Box)(({ theme }) => ({
  width: "32.5%", // Each card takes 30% of the parent width
  backgroundColor: "#f8f9fa", // Light background for the card
  borderRadius: "5px",
  boxShadow: "0px 0 30px rgba(0, 0, 0, 0.1)", // Subtle shadow
  overflow: "hidden",
  padding: "1rem",
}));

// Card header with background color
export const CardInfoHeader = styled("div")(({ theme }) => ({
  color: "#364A65", // White text color
  fontSize: "1.2rem",
  fontWeight: "bold",
  textAlign: "left",
  padding: ".25rem",
  paddingLeft: ".75rem",
  "& hover": {
    backgroundColor: "#364A65",
    color: "rgb(168 40 40)",
  },
}));

// Card content styling
export const CardInfoContent = styled("div")({
  padding: "1 rem",
  "& p": {
    marginBottom: "1rem",
    lineHeight: "1.4",
  },
});

// Read More button styling
export const ReadMoreButton = styled(Button)(({ theme }) => ({
  marginTop: "1rem",
  backgroundColor: "#4caf50",
  color: "white",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export const FPFooterWrapper = styled(Box)(({ theme }) => ({
  padding: "7px",
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
  color: "#ffffff",
  textAlign: "center",
  borderTop:"1px solid #ffffff3b"
}));


export const FooterFPText = styled(Typography)(({ theme }) => ({
  // marginBottom: "0.5rem", // Space between paragraphs
  display: "flex",
  flexDirection: "column",
  fontSize: "11px", // You can adjust the font size as per your needs
  textAlign: "center",
  alignItems: "center",
}));

export const AboveFooterWrappers = styled(Box)(({ theme }) => ({
  backgroundColor: "#253243",
  color: "#ffffff",
  padding: "2rem",
}));

// Styling for the Social Media icons
export const SocialIcons = styled(Box)(({ theme }) => ({
  display: "inline-block",
  margin: "10px",
  "& svg": {
    fontSize: "2rem",
    color: "#1c1052",
    transition: "color 0.3s",
    "&:hover": {
      color: theme.palette.primary.main, // You can customize hover color
    },
  },
}));

export const AddressCard = styled(Card)(({ theme }) => ({
  padding: "0.4rem",
  backgroundColor: "#fff",
  boxShadow: "0px 0 20px rgba(0, 0, 0, 0.1)",
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
  width: "100%",
  maxWidth: "500px",
  marginBottom: "2rem",
  height: "400px",
}));

export const FormCard = styled(Card)(({ theme }) => ({
  padding: "0.5rem",
  backgroundColor: "#fff",
  display: "flex",
  flexDirection: "column",
  gap: "0.5 rem",
  width: "100%",
  maxWidth: "500px",
  marginBottom: "2rem",
  height: "400px",
}));

export const CardWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-around",
  gap: "2rem",
  flexWrap: "wrap",
  marginTop: "2rem",
}));

export const HeaderContainer = styled(Container)(({ theme }) => ({
  maxWidth: theme.breakpoints["lg"],
  justifyContent: "space-between",
  paddingBlock: theme.spacing(1),
  alignItems: "center",
  display: "flex",
}));
export const HeaderTitle = styled(Box)(() => ({
  textAlign: "center",
}));
export const Title1 = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.fontSize,
  color: theme.palette.grey["50"],
  [theme.breakpoints.up("lg")]: {
    fontSize: theme.typography.fontSize * 1.4,
    color: theme.palette.mode === "dark" ? theme.palette.grey["100"] : "#191B20",
  },
}));
export const Title2 = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.fontSize,
  color: theme.palette.grey["100"],
  [theme.breakpoints.up("lg")]: {
    fontSize: theme.typography.fontSize * 1.6,
    color: theme.palette.mode === "dark" ? theme.palette.grey["50"] : "#0C0D10",
  },
}));

///// Navigation Menu
export const MenuWrapper = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text,
}));
export const NavContainer = styled(Container)(({ theme }) => ({
  maxWidth: theme.breakpoints["lg"],
  minHeight: theme.spacing(6.25),

  [theme.breakpoints.up("lg")]: {
    color: theme.palette.common.black,
    backgroundColor: "transparent",
    minHeight: theme.spacing(5),
  },

  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text,
}));
export const NavToolbar = styled(Toolbar)(({ theme }) => ({
  maxWidth: theme.breakpoints["lg"],
  justifyContent: "space-between",
  padding: theme.spacing(0.5, 0),
  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(1, 0),
    justifyContent: "center",
  },
  minHeight: theme.spacing(4),
  columnGap: theme.spacing(1),
  textAlign: "center",
}));
export const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiMenu-paper": {
    backgroundColor: theme.palette.ud.primary.main,
    borderRadius: theme.shape.borderRadius * 0.75,
    translateY: theme.spacing(0.5),
    minWidth: 140,

    "& .MuiButton-root": {
      paddingInline: theme.spacing(2),
      textAlign: "left",
      display: "block",
      width: "100%",
    },
  },
}));
export const MenuItem = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 0.5,
  color: theme.palette.primary.contrastText,
  paddingBlock: theme.spacing(0.25),
}));
export const StyledDivider = styled(Divider)(({ theme }) => ({
  height: theme.spacing(3.25) + " !important",
  color: theme.palette.grey["50"],
  alignSelf: "center",
}));
export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    backgroundColor: theme.palette.ud.primary.main,
    boxSizing: "border-box",
    overflow: "hidden",
    "& .subMenu": {
      backgroundColor: alpha(theme.palette.common.black, 0.1),
      paddingInline: theme.spacing(2),

      "& .MuiButton-root": {
        display: "block",
        textAlign: "left",
        width: "100%",
      },
    },
    "& .MuiButton-root": {
      paddingInline: theme.spacing(2),
      justifyContent: "space-between",
      lineHeight: theme.spacing(5),
      borderRadius: 0,
      "&.MuiButton-contained, &.MuiButton-outlined": {
        paddingInline: theme.spacing(3),
      },
      "&.MuiButton-outlined": {
        borderColor: alpha(theme.palette.common.black, 0.1),
      },
    },
    "& .MuiDivider-vertical": {
      height: "1px !important",
      display: "block",
      width: "100%",
    },
  },
}));

///// Hero Section
export const HeroWrapper = styled(Box)(({ theme, bgimg }) => ({
  background: `${theme.palette.grey["200"]} url('${bgimg}') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  minHeight: `calc(100dvh - 50px)`,
  position: "relative",

  [theme.breakpoints.up("lg")]: {
    minHeight: `calc(100dvh - 150px)`, // updated height 225px to 150px till achar sanhita
  },
}));
export const HeroTopLeftMessage = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.25),
  fontWeight: theme.typography.fontWeightMedium,
  textShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.75)",
  inset: theme.spacing(4, 4, "auto", 4),
  [theme.breakpoints.up("sm")]: {
    inset: theme.spacing(4, "auto", "auto", 4),
  },
  fontSize: theme.typography.fontSize * 1.4,
  color: theme.palette.common.white,
  borderRadius: theme.spacing(0.5),
  backdropFilter: "blur(1px)",
  padding: theme.spacing(2),
  position: "absolute",
}));
export const HeroMantriStrip = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.7),
  inset: theme.spacing("auto", 0, 2),
  color: theme.palette.common.white,
  padding: theme.spacing(3, 4),
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(3, 8),
  },
  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(3, 12),
  },
  backdropFilter: "blur(1px)",
  position: "absolute",
}));
export const PersonCard = styled(Grid)(({ theme }) => ({
  justifyContent: "space-between",
  gap: theme.spacing(2),
  alignItems: "center",
  display: "flex",
}));
export const PersonPic = styled(Box)(({ theme }) => ({
  "& img": {
    objectFit: "cover",
    display: "block",
    height: 80,
    width: 80,
  },
}));
export const PersonDesc = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.fontSize,
  color: theme.palette.common.white,
  flex: 1,

  "& strong": {
    fontWeight: theme.typography.fontWeightMedium,
    display: "block",
  },
}));

///// Services
export const ServicesContainer = styled(Container)(({ theme }) => ({
  maxWidth: theme.breakpoints["lg"],
  paddingBlock: theme.spacing(4),
}));
export const ServiceGrid = styled(Grid)(({ theme }) => ({
  justifyContent: "center",

  "& .MuiButtonBase-root": {
    fontWeight: theme.typography.fontWeightSemiBold,
    flexDirection: "column",
    textAlign: "center",
    width: "100%",
    flex: 1,

    "& img": {
      marginBottom: theme.spacing(1),
      display: "block",
      margin: "auto",
      maxWidth: 150,
    },
  },
}));

///// AppDetails
export const AppDetailsWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.ud.primary.main,
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.ud.primary.text,
  paddingBlock: theme.spacing(3.75),
}));
export const AppDetailsContainer = styled(Container)(({ theme }) => ({
  maxWidth: theme.breakpoints["lg"],
}));
export const AppDetailsHead = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.fontSize * 2,
  marginBottom: theme.spacing(2),
  textTransform: "uppercase",
}));
export const AppDetailsLabel = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.fontSize * 1.5,
}));
export const AppDetailsValue = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.fontSize * 6,
}));

///// Checklist and Feedback Form
export const FormsContainer = styled(Container)(({ theme }) => ({
  maxWidth: theme.breakpoints["lg"],
  paddingBlock: theme.spacing(3),
  flexDirection: "column",
  alignItems: "stretch",
  display: "flex",

  [theme.breakpoints.up("md")]: {
    alignItems: "flex-start",
    flexDirection: "row",
  },

  "& > div": {
    flex: 1,
    textAlign: "center",
    padding: theme.spacing(2, 3, 3),
    "&.feedbackForm": { paddingInline: 0 },
    [theme.breakpoints.up("md")]: {
      "&.feedbackForm": { padding: theme.spacing(2, 3, 3) },
      textAlign: "right",
    },
    "& .title": {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.5,
      color: theme.palette.ud.primary.main,
      marginBottom: theme.spacing(1.5),
      textTransform: "uppercase",
      textAlign: "left",
    },
  },
}));
export const ChecklistWrapper = styled(Box)(({ theme }) => ({
  border: "1px solid #F7A143",
  marginInline: "auto",
  maxWidth: 530,

  "& .content": {
    marginBottom: theme.spacing(2),
    textAlign: "left",

    "& p": {
      fontSize: theme.typography.fontSize,
      marginBottom: theme.spacing(1),
    },
  },
  "& .MuiButton-root": {
    color: theme.palette.ud.primary.main,
    textTransform: "unset",
  },
}));
export const FeedbackWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0),
  textAlign: "center",
  [theme.breakpoints.up("md")]: {
    textAlign: "right",
  },
}));
export const FormContainer = styled(Box)(({ theme }) => ({
  marginInline: "auto",
  textAlign: "center",
  maxWidth: 530,
  [theme.breakpoints.up("md")]: {
    textAlign: "left",
    marginRight: 0,
    maxWidth: 450,
  },
  '& button[type="submit"]': {
    width: "100%",
  },
  "&.tcp": {
    "& .title": {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.5,
      color: theme.palette.tcp.primary.main,
      marginBottom: theme.spacing(1.5),
      marginRight: theme.spacing(4),
      textTransform: "uppercase",
      textAlign: "center",
    },
    "& .MuiFormGroup-root": {
      "& label .MuiFormControlLabel-label, & label svg": {
        color: theme.palette.tcp.primary.main,
      },
      "& label svg": {
        fill: theme.palette.tcp.primary.main,
      },
      justifyContent: "center",
      gap: theme.spacing(2),

      "& .MuiButtonBase-root": {
        padding: theme.spacing(1),
      },
    },
  },
}));
export const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  "& label": {
    "&.MuiFormControlLabel-root": { marginBottom: 0 },
    "& .MuiFormControlLabel-label": {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.1,
      color: theme.palette.ud.primary.main,
    },

    "& svg": {
      fill: theme.palette.ud.primary.main,
    },
  },
}));

///// Footer
export const FooterWrapper = styled("footer")(({ theme }) => ({
  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text,
  fontSize: theme.typography.fontSize,
  padding: theme.spacing(1),
  textAlign: "center",
}));

export const TcpFooterWrapper = styled("footer")(({ theme }) => ({
  backgroundColor: theme.palette.tcp.primary.main,
  color: theme.palette.ud.primary.text,
  fontSize: theme.typography.fontSize,
  padding: theme.spacing(1),
  textAlign: "center",
}));
